import { createSlice } from '@reduxjs/toolkit'
import { fbAuth, fbDb } from '../../app/firebase'
import { onAuthStateChanged } from 'firebase/auth'
import { doc, onSnapshot } from 'firebase/firestore'

export const authSlice = createSlice({
  name: 'auth',
  initialState: {
    currentUser: null,    // Firebase Auth user
    firestoreUser: null,  // Firestore user document (live)
    isLoading: true,
  },
  reducers: {
    setAuthUser: (state, action) => {
      state.currentUser = action.payload
      state.isLoading = false
    },
    setFirestoreUser: (state, action) => {
      state.firestoreUser = action.payload
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload
    },
  },
})

export const {
  setAuthUser,
  setFirestoreUser,
  setLoading,
} = authSlice.actions

// Firebase authentication
export const initializeAuthListener = () => (dispatch) => {
  dispatch(setLoading(true))
  let unsubSnapshot = null
  const stopUserDocListener = () => {
    if (unsubSnapshot) {
      unsubSnapshot()
      unsubSnapshot = null
    }
  }

  // listen for Firebase Auth changes
  const unsubAuth = onAuthStateChanged(fbAuth, (user) => {
    stopUserDocListener()

    if (user) {
      const { displayName, email, phoneNumber, uid } = user
      dispatch(setAuthUser({ displayName, email, phoneNumber, uid }))

      // realtime then subscribe to the Firestore user doc
      const userDocRef = doc(fbDb, 'users', uid)
      unsubSnapshot = onSnapshot(userDocRef, (docSnap) => {
        if (docSnap.exists()) {
          dispatch(setFirestoreUser(docSnap.data()))
        } else {
          dispatch(setFirestoreUser(null))
        }
        dispatch(setLoading(false))
      })
    } else {
      // logged out
      dispatch(setAuthUser(null))
      dispatch(setFirestoreUser(null))
      dispatch(setLoading(false))
    }
  })

  //cleanup
  return () => {
    stopUserDocListener()
    unsubAuth()
  }
}

export const selectCurrentUser = (state) => state.auth.currentUser
export const selectFirestoreUser = (state) => state.auth.firestoreUser
export const authIsLoading = (state) => state.auth.isLoading

export default authSlice.reducer
